import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      // If not on home page, navigate to home first
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
    closeMobileMenu();
  };

  return (
    <header className="fixed w-full bg-white shadow-sm z-50">
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="text-2xl font-['Pacifico'] text-primary">Krishna API HUB</Link>
        
        <nav className="hidden md:flex items-center space-x-8">
          <button 
            onClick={() => scrollToSection('#about')} 
            className="text-gray-700 hover:text-primary transition-colors"
          >
            About
          </button>
          <button 
            onClick={() => scrollToSection('#problems')} 
            className="text-gray-700 hover:text-primary transition-colors"
          >
            Problems We Solve
          </button>
          <button 
            onClick={() => scrollToSection('#services')} 
            className="text-gray-700 hover:text-primary transition-colors"
          >
            Solutions
          </button>
          <button 
            onClick={() => scrollToSection('#case-studies')} 
            className="text-gray-700 hover:text-primary transition-colors"
          >
            ERP Case Study
          </button>
          <button 
            onClick={() => scrollToSection('#advantages')} 
            className="text-gray-700 hover:text-primary transition-colors"
          >
            Results
          </button>
          <button 
            onClick={() => scrollToSection('#program')} 
            className="text-gray-700 hover:text-primary transition-colors"
          >
            Startup Program
          </button>
          <Link 
            to="/faq" 
            className="text-gray-700 hover:text-primary transition-colors"
          >
            FAQ
          </Link>
          <button 
            onClick={() => scrollToSection('#contact')} 
            className="text-gray-700 hover:text-primary transition-colors"
          >
            Contact
          </button>
        </nav>
        
        <div className="flex items-center space-x-4">
          <button 
            onClick={() => scrollToSection('#contact')} 
            className="hidden md:block px-5 py-2 bg-primary text-white font-medium !rounded-button hover:bg-primary/90 transition-colors whitespace-nowrap"
          >
            Get a Free Consultation
          </button>
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700"
            onClick={toggleMobileMenu}
          >
            <i className={isMobileMenuOpen ? "ri-close-line ri-lg" : "ri-menu-line ri-lg"}></i>
          </button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      <div className={`md:hidden ${isMobileMenuOpen ? 'block' : 'hidden'} bg-white w-full shadow-md`}>
        <div className="container mx-auto px-6 py-4 flex flex-col space-y-4">
          <button 
            onClick={() => scrollToSection('#about')} 
            className="text-gray-700 py-2 hover:text-primary transition-colors text-left"
          >
            About
          </button>
          <button 
            onClick={() => scrollToSection('#problems')} 
            className="text-gray-700 py-2 hover:text-primary transition-colors text-left"
          >
            Problems We Solve
          </button>
          <button 
            onClick={() => scrollToSection('#services')} 
            className="text-gray-700 py-2 hover:text-primary transition-colors text-left"
          >
            Solutions
          </button>
          <button 
            onClick={() => scrollToSection('#case-studies')} 
            className="text-gray-700 py-2 hover:text-primary transition-colors text-left"
          >
            ERP Case Study
          </button>
          <button 
            onClick={() => scrollToSection('#advantages')} 
            className="text-gray-700 py-2 hover:text-primary transition-colors text-left"
          >
            Results
          </button>
          <button 
            onClick={() => scrollToSection('#program')} 
            className="text-gray-700 py-2 hover:text-primary transition-colors text-left"
          >
            Startup Program
          </button>
          <Link 
            to="/faq" 
            onClick={closeMobileMenu}
            className="text-gray-700 py-2 hover:text-primary transition-colors text-left"
          >
            FAQ
          </Link>
          <button 
            onClick={() => scrollToSection('#contact')} 
            className="text-gray-700 py-2 hover:text-primary transition-colors text-left"
          >
            Contact
          </button>
          <button 
            onClick={() => scrollToSection('#contact')} 
            className="block px-5 py-2 bg-primary text-white font-medium text-center !rounded-button hover:bg-primary/90 transition-colors whitespace-nowrap"
          >
            Get a Free Consultation
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
